import styled from 'styled-components';
import { Atom } from 'AppReact';

export const template = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${window?.settings?.secondary_color ?? '#04333b'};
`;

export default Atom({ type: 'label', dataType: 'string', template })